import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useTranslations } from 'next-intl';
import StyledTokenInput from './tokenInput.style';
import Copy from '../copy/copy';

const TokenInput = ({
  onChange = () => {},
  onFocus = () => {},
  label,
  value = '',
  name,
  maxLength = 100,
  required = false,
  error = false,
  placeholder,
  insideNavigation = false,
  ...props
}) => {
  const t = useTranslations();
  const inputRef = useRef(null);

  const handleFocus = () => {
    onFocus();
  };

  return (
    <StyledTokenInput {...props} insideNavigation={insideNavigation}>
      <div className="tokenInput__container">
        {placeholder && !label && (
          <label htmlFor="tokenInput" className="sr-only">
            {placeholder}
          </label>
        )}
        {label && (
          <label htmlFor="tokenInput" className="sr-only">
            {label}
          </label>
        )}
        <input
          ref={inputRef}
          maxLength={maxLength}
          onChange={onChange}
          onFocus={e => handleFocus(e)}
          value={value}
          name={name}
          required={required}
          placeholder={placeholder}
          type="text"
          id="tokenInput"
          autoComplete="off"
        />
      </div>
      {label && <span className="tokenInput__label">{label}</span>}

      {error && (
        <Copy className="tokenInput__instructions" small>
          {t('loginMask.error')}
        </Copy>
      )}
    </StyledTokenInput>
  );
};

TokenInput.propTypes = {
  insideNavigation: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  maxLength: PropTypes.number,
  error: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string.isRequired
};

export default TokenInput;
